import {
  getAllProducts,
  getFilteredProducts,
  postProduct,
  updateProduct,
  disableProduct
} from '@/api/Erp'

export default {
  async getAllProducts(page, size, token) {
    try {
      const response = await getAllProducts.get({
        uriParams: {
          page,
          size
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response.data
    } catch (error) {
      return error.response
    }
  },
  async getFilteredProducts(is_active, page, size, token) {
    try {
      const response = await getFilteredProducts.get({
        uriParams: {
          is_active,
          page,
          size
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response.data
    } catch (error) {
      return error.response
    }
  },
  async postProduct(payload, token) {
    try {
      const response = await postProduct.post(
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async updateProduct(payload, token) {
    const product_id = payload.product_id
    try {
      const response = await updateProduct.patch(
        {
          product_name: payload.product_name,
          product_is_active: payload.product_is_active
        },
        {
          uriParams: {
            id: product_id
          },
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async disableProductDelete(payload, token) {
    const product_id = payload.product_id
    try {
      const response = await disableProduct.delete({
        uriParams: {
          id: product_id
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/product/resources.js